import * as React from 'react';
import { Play } from '@volkswagen-onehub/icons-core';
import { MediaContext } from '..';
import { CTA } from '../../call-to-action';
import { styled } from '../../theme-provider';
const StyledPlayButtonCenter = styled(CTA).withConfig({ displayName: "StyledPlayButtonCenter", componentId: "sc-14knx0f" }) `position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);`;
export const PlayButtonCenter = (props) => {
    const mediaElement = React.useContext(MediaContext);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const handlePlay = React.useCallback(() => {
        setIsPlaying(true);
    }, []);
    const handleEnded = React.useCallback(() => {
        setIsPlaying(false);
    }, []);
    React.useEffect(() => {
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('play', handlePlay);
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('ended', handleEnded);
        return () => {
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('play', handlePlay);
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('ended', handleEnded);
        };
    }, [handleEnded, handlePlay, mediaElement]);
    const handleClick = React.useCallback((event) => {
        if (mediaElement) {
            event.preventDefault();
            event.stopPropagation();
            mediaElement.play();
        }
    }, [mediaElement]);
    if (isPlaying) {
        return null;
    }
    return (React.createElement(StyledPlayButtonCenter, { tag: "button", emphasis: "tertiary", onClick: handleClick, title: props.playTitle, ariaLabel: props.playTitle, icon: React.createElement(Play, { ariaHidden: true }) }));
};
PlayButtonCenter.displayName = 'PlayButtonCenter';
